<template>
	<div>
		<van-nav-bar title="景点列表" left-text="返回" left-arrow @click-left="onClickLeft" class="navbar" />
		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="image in images" :key="image">
				<img :src="image.src" width="100%" height="100%" />
			</van-swipe-item>
		</van-swipe>
		<div class="search-wrapper">
			<van-search class="search" shape="round" v-model="value" placeholder="请输入搜索关键词" />
		</div>

		<van-tabs v-model:active="active">
			<van-tab :title="scenicspot.type" v-for="scenicspot in scenicspotList" :key="scenicspot"
				title-style="fontSize:15px">
				<div class="scenicspotList" v-for="item in scenicspot.list" :key="item">
					<img class="image" :src="item.imgUrl" />
					<p class="title">{{item.title}}</p>
					<van-rate class="rate" v-model="item.rate" :size="16" />
					<p class="addr">{{item.addr}}</p>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {
		reactive
	} from 'vue';
	export default {
		setup() {
			const images = reactive([{
					src: require('@/assets/image/banner1.jpg')
				},
				{
					src: require('@/assets/image/banner2.jpg')
				},
				{
					src: require('@/assets/image/banner3.png')
				}
			]);
			//内容
			const scenicspotList = [{
					type: '草原风光',
					list: [{
							title: '远离喧嚣的避暑秘境',
							addr: '贵州荔波洪江村',
							rate: 5,
							imgUrl: require('@/assets/image/grassland1.jpeg')
						},
						{
							title: '洪江国际艺术村风光',
							addr: '贵州荔波洪江村',
							rate: 3,
							imgUrl: require('@/assets/image/fg.jpg')
						},
						{
							title: '休闲、度假的世外桃园',
							addr: '贵州荔波洪江村',
							rate: 3,
							imgUrl: require('@/assets/image/fg2.jpg')
						},
						{
							title: '洪江村盛开的油菜花',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ych.jpg')
						}
					]
				},
				{
					type: '名胜古迹',
					list: [{
							title: '“隐”在乡间里的“艺术国度',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/history1.jpeg')
						},
						{
							title: '被世界旅游联盟评选的艺术村落',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/history2.jpeg')
						},
						{
							title: '择一处庭院，享一处清幽',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/history3.jpeg')
						},
						{
							title: '当文艺的唯美遇上田园的馨香',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/history4.jpeg')
						}
					]
				},
				{
					type: '生态洪江',
					list: [{
							title: '艺农“牵手”点亮村民眼中的光',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ecology1.jpg')
						},
						{
							title: '荔波洪江村：秋日丰景美',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ecology2.jpeg')
						},
						{
							title: '黔南避暑天堂“网红国际艺术村”',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ecology3.jpeg')
						},
						{
							title: '置身花海，沐浴荷香”',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ecology4.jpeg')
						}
					]
				},
				{
					type: '乡村旅游',
					list: [{
							title: '置身花海，沐浴荷香”',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/ecology4.jpeg')
						},
						{
							title: '荔波洪江村：稻田捉鱼',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/travel.jpg')
						},
						{
							title: '美丽洪江:研学实践',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/travel2.jpg')
						},
						{
							title: '村寨文化浓厚、民俗文化绚丽',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/travel3.jpg')
						}
					]
				},
				{
					type: '乡村艺术',
					list: [{
							title: '洪江艺术村：共居艺术生活',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/art1.jpg')
						},
						{
							title: '大山深处的艺术村——洪江村',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/art2.jpg')
						},
						{
							title: '艺术“点化”乡村 向美而行',
							addr: '贵州荔波洪江村',
							rate: 4,
							imgUrl: require('@/assets/image/art3.png')
						}
					]
				}
			]
			return {
				images,
				scenicspotList
			};


		},
	}
</script>

<style scoped>
	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		height: 300px;
		text-align: center;
	}

	.van-search {
		width: 90%;
		margin-left: 5%;
		text-align: center;
		margin-top: 10px;
	}

	.van-field__left-icon,
	.van-field__body {
		height: 60px;
		line-height: 60px;
	}

	.van-field__control {
		line-height: 60px;
	}

	.scenicspotList {
		width: 96%;
		height: 260px;
		margin-left: 2%;
		background: #fdfdfd;
		margin-top: 10px;
		border-radius: 10px;
		position: relative;
	}

	.image {
		width: 250px;
		height: 200px;
		border-radius: 10px;
		margin: 20px;
	}

	.title {
		display: inline-block;
		font-size: 36px;
		position: absolute;
		top: 20px;
	}

	.addr {
		display: inline-block;
		font-size: 30px;
		position: absolute;
		top: 180px;
		color: #737373;
	}

	.rate {
		position: absolute;
		margin-top: 125px;
	}

	/deep/.van-tabs__wrap {
		height: 80px !important;
	}

	/deep/.van-tabs__wrap {
		height: 80px;
	}

	/deep/.van-tabs__nav {
		height: 80px;
		/* background-color: green; */
	}

	/deep/.van-tab__text {
		line-height: 80px;
	}

	/deep/.van-nav-bar__content {
		height: 80px;
	}

	/deep/.van-nav-bar__title {
		font-size: 30px;
		line-height: 50px;
	}

	/deep/.van-nav-bar__text {
		font-size: 30px;
	}

	/deep/.van-field__control {
		height: 50px;
	}

	/deep/.van-field__left-icon {
		margin-top: 15px;
	}

	/deep/.van-field__control {
		font-size: 24px
	}

	/* 调整 van-search 的图标大小 */
	/deep/ .van-icon-search::before {
		font-size: 30px;
		/* 根据需要调整图标大小 */
	}
</style>
